<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right">
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column label="操作" fixed="right" align="center" width="180">
          <template slot-scope="{row}">
            <el-button type="text" @click="edit(row,0)" v-if="!row.SignInTime&&!row.SignInFilingTime">签到报备</el-button>
            <el-button type="text" @click="toClear(row,0)" v-else-if="!row.SignInTime">取消签到报备</el-button>
            <el-button type="text" @click="edit(row,1)" v-if="!row.SignOutTime&&!row.SignOutFilingTime">签退报备</el-button>
            <el-button type="text" @click="toClear(row,1)" v-else-if="!row.SignOutTime">取消签退报备</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload"></edit-dialog>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/fa/filing/list";
import editDialog from "@/components/fa/filing/editDialog";

export default {
  name: "filing",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
  },
  data() {
    return {
      api: require("@/api/attendance/teachersetting").default,
      isMB: this.$store.state.isMB,
    }
  },
  methods: {
    edit(row,type) {
      if(type==1 && !row.SignInFilingTime) {
        this.$message.error("未签到的记录不能报备签退");
        return;
      }
      this.$refs.editDialog.openEdit({ 
        id: row.AttendanceTaskDtsId,
        date: row.EventDate,
        si: row.SignInFilingTime,
        so: row.SignOutFilingTime,
        s: row.TimeBucketStart,
        e: row.TimeBucketEnd,
        type 
      })
    },
    toClear(row,type) {
      if(type==0 && row.SignOutFilingTime) {
        this.$message.error("有签退报备的记录不能取消签到报备");
        return;
      }
      this.$confirm("确认取消报备时间吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var obj = {
            AttendanceTaskDtsId: row.AttendanceTaskDtsId,
            Type: type,
            SignInFilingTime: row.SignInFilingTime,
            SignOutFilingTime: row.SignOutFilingTime
          };
          if(type==0) {
            obj.SignInFilingTime = "";
          } else {
            obj.SignOutFilingTime = "";
          }
          this.api.taskFiling(obj).then(res => {
            if(res.Code==0) {
              this.$message.success("取消报备成功");
              this.reload();
            } else {
              this.$message.error(res.Msg);
            }
          })
        })
        .catch(() => {});
    },
  }
};
</script>